// The full Cypress Boys roster, shown in THE CYPRESS BOYS section.
// Add or remove members freely — the section sorts alphabetically
// by last name on its own. Nicknames come from nicknames.js.
//
// IMPORTANT: names here must match the spelling in rounds.js
// exactly. If a name shows up in rounds.js that is not on this
// list, the site logs a console warning — a typo creates a phantom
// player.
export const ROSTER = [
  "Alex Hall",
  "Arvin Persaud",
  "Barry Borrilez",
  "Bijon Hughes",
  "Brian Brewer",
  "Chase Hascup",
  "Chuck Kahuli",
  "Clint Birch",
  "Dylan McIntyre",
  "Ed Hascup",
  "Fred Brown",
  "Fred Longoria",
  "Garrett Walker",
  "Ian Hall",
  "Jamie Haneca",
  "Javier Hernandez",
  "Jeff Robinson",
  "Jeremiah Tongkhoyam",
  "Jeremy Ducharme",
  "Joe Lopez",
  "Jose Cruz",
  "Kurt Crigger",
  "Marc Sillanpaa",
  "Martin Bajala",
  "Matt Thomas",
  "Michael Hether",
  "Nelson Prouty",
  "Nick Sivil",
  "Noom Tunsatian",
  "Reggie Jones",
  "Ric Buesgen",
  "Ricky Munoz",
  "Ron Cappel",
  "Sam Thomas",
  "Scott Lewis",
  "Tom Jackson",
  "Tony Amaral",
  "Troy Ham",
  "Wayne Carter",
  "Will Wartick",
];
